import { CALL_API } from 'middlewares/api';
import { url } from 'configs';
const {
  NEWTUBE_API_SERVER,
} = url;

const FETCH_RECEIVEDDATA_REQUEST = 'tube/stickynotes/received/FETCH_RECEIVEDDATA_REQUEST';
const FETCH_RECEIVEDDATA_SUCCESS = 'tube/stickynotes/received/FETCH_RECEIVEDDATA_SUCCESS';
const FETCH_RECEIVEDDATA_FAIL = 'tube/stickynotes/received/FETCH_RECEIVEDDATA_FAIL';

const DELETE_RECEIVEDDATA_REQUEST = 'tube/stickynotes/received/DELETE_RECEIVEDDATA_REQUEST';
const DELETE_RECEIVEDDATA_SUCCESS = 'tube/stickynotes/received/DELETE_RECEIVEDDATA_SUCCESS';
const DELETE_RECEIVEDDATA_FAIL = 'tube/stickynotes/received/DELETE_RECEIVEDDATA_FAIL';

const PUT_RECEIVEDDATA_READ_REQUEST = 'tube/stickynotes/received/PUT_RECEIVEDDATA_READ_REQUEST';
const PUT_RECEIVEDDATA_READ_SUCCESS = 'tube/stickynotes/received/PUT_RECEIVEDDATA_READ_SUCCESS';
const PUT_RECEIVEDDATA_READ_FAIL = 'tube/stickynotes/received/PUT_RECEIVEDDATA_READ_FAIL';

export default function reducer(state = {
  isLoading: false,
  datas: {},
}, action) {
  switch (action.type) {
    case FETCH_RECEIVEDDATA_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case FETCH_RECEIVEDDATA_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        datas: action.response,
      });
    default:
      return state;
  }
}

export function fetchReceivedData(PageNumber) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'PostNote/Received?PageNumber=' + PageNumber,
      method: 'GET',
      types: [
        FETCH_RECEIVEDDATA_REQUEST,
        FETCH_RECEIVEDDATA_SUCCESS,
        FETCH_RECEIVEDDATA_FAIL,
      ],
    },
  };
}

export function deleteReceivedData(PostNoteToId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'PostNote/Received/' + PostNoteToId,
      method: 'Delete',
      types: [
        DELETE_RECEIVEDDATA_REQUEST,
        DELETE_RECEIVEDDATA_SUCCESS,
        DELETE_RECEIVEDDATA_FAIL,
      ],
    },
  };
}

export function putReceivedDataRead(PostNoteToId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'PostNote/Received/' + PostNoteToId + '/Read',
      method: 'PUT',
      types: [
        PUT_RECEIVEDDATA_READ_REQUEST,
        PUT_RECEIVEDDATA_READ_SUCCESS,
        PUT_RECEIVEDDATA_READ_FAIL,
      ],
    },
  };
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/screens/StickyNotes/screens/Received/reducers/index.js
 **/